import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './CCAvenue.css';

const CCAvenue = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [paymentData, setPaymentData] = useState(null);
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const extractPaymentData = () => {
      const data = {};
      
      // Extract from URL query parameters
      searchParams.forEach((value, key) => {
        data[key] = value;
      });
      
      // Extract from POST data (if available in location state)
      if (location.state) {
        Object.assign(data, location.state);
      }
      
      // Extract from hash fragment
      if (location.hash) {
        const hashParams = new URLSearchParams(location.hash.substring(1));
        hashParams.forEach((value, key) => {
          data[key] = value;
        });
      }
      
      // Determine status from various possible fields
      const orderStatus = data.order_status || data.orderStatus || data.status;
      
      if (orderStatus) {
        setStatus(orderStatus.toLowerCase() === 'success' ? 'success' : 
                  orderStatus.toLowerCase() === 'failure' ? 'failure' : 'pending');
      } else if (data.encResp) {
        // If encrypted response exists, status is pending until decrypted
        setStatus('pending');
      }
      
      setPaymentData(data);
      processPayment(data);
      
      // Signal automated browser to close
      console.log('AUTOMATED_BROWSER_CLOSE_NOW');
    };

    extractPaymentData();
  }, [location, searchParams]);

  const processPayment = async (data) => {
    try {
      console.log('Payment data received:', data);
      
      // TODO: Send to backend for decryption and verification
      // const response = await axios.post('/api/payment/verify', data);
      // setStatus(response.data.status);
    } catch (error) {
      console.error('Payment processing error:', error);
      setStatus('failure');
    }
  };

  return (
    <div className="ccavenue-container">
      <div className="ccavenue-card">
        {status === 'processing' && (
          <>
            <div className="ccavenue-spinner"></div>
            <h2 className="ccavenue-title">Processing Payment</h2>
            <p className="ccavenue-message">Please wait while we verify your payment...</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="ccavenue-status status-success">✓ Payment Successful</div>
            <h2 className="ccavenue-title">Thank You!</h2>
            <p className="ccavenue-message">Your payment has been processed successfully.</p>
          </>
        )}
        
        {status === 'failure' && (
          <>
            <div className="ccavenue-status status-failure">✗ Payment Failed</div>
            <h2 className="ccavenue-title">Payment Unsuccessful</h2>
            <p className="ccavenue-message">There was an issue processing your payment.</p>
          </>
        )}
        
        {status === 'pending' && (
          <>
            <div className="ccavenue-status status-pending">⏳ Payment Pending</div>
            <h2 className="ccavenue-title">Payment Pending</h2>
            <p className="ccavenue-message">Your payment is being processed.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default CCAvenue;
